enquire.register("all and (max-width: 851px)", {
    match:function(){
        $(".js-footer_content_open").show();
        $(".js-footer_content").hide();
    },
    unmatch:function(){
        // Desktop
        $(".js-footer_content_close").hide();
        $(".js-footer_content_open").hide();
        $(".js-footer_content").show();
    }
});

$(document).on("click", ".js-footer_content_toggle", function(e){
    e.preventDefault(e);
    if($(this).find(".js-footer_content_close").is(":visible")){
        $(this).find(".js-footer_content_close").hide();
        $(this).find(".js-footer_content_open").show();
        $(this).siblings(".js-footer_content").slideUp(150);
    }else if($(this).find(".js-footer_content_open").is(":visible")){
        $(this).find(".js-footer_content_close").show();
        $(this).find(".js-footer_content_open").hide();
        $(this).siblings(".js-footer_content").slideDown(150);
    }
})

